import React, { useEffect, useState } from "react";
import { DateRange } from 'react-date-range';
import CoachSideBar from "../components/Coach/Profile/CoachSideBar";
import Navbar from "../components/Navbar";
import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { enqueueSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAvailabilityDocumentById, updateAvailabilityById } from "../actions/userAuth";
import UserLayout from "../assets/UserLayout";
import Layout from "../assets/Layout";

const EditAvailability = () => {
    const { id } = useParams();
    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: null,
            key: 'selection'
        }
    ]);
    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedEndTime, setSelectedEndTime] = useState(null);
    const [selectedDates, setSelectedDates] = useState([]);
    const dispatch = useDispatch();
    const { user } = useSelector((state) => ({ ...state }));
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getAvailabilityDocumentById({ id }, (data) => {
            console.log(data.data.data)
            setSelectedDates(data.data.data[0].availability);
            setState([
                {
                    startDate: new Date(data.data.data[0].availability[0].selectedDate),
                    endDate: new Date(data.data.data[0].availability[data.data.data[0].availability.length - 1].selectedDate),
                    key: 'selection'
                }
            ])
            setSelectedTime(new Date("1970-01-01 " + data.data.data[0].availability[0].startTime));
            setSelectedEndTime(new Date("1970-01-01 " + data.data.data[0].availability[0].endTime));
        }))
    }, [id]);
    const handleTimeChange = (time) => {
        console.log(time);
        setSelectedTime(time);
    };

    const handleTimeEndChange = (time) => {
        setSelectedEndTime(time);
    };

    const handleAddAvailability = () => {
        if (!selectedTime || !selectedEndTime) {
            enqueueSnackbar("Please fill correct start and end time", { variant: 'warning' });
        } else if (!state[0].startDate || !state[0].endDate) {
            enqueueSnackbar("Please select the correct dates", { variant: 'warning' });
        } else {
            let dates = getDatesBetween(state[0].startDate, state[0].endDate);
            let arr = [];
            for (var index = 0; index < dates.length; index++) {
                var date = new Date(dates[index]);

                var options = { day: 'numeric', month: 'long', weekday: 'short' };

                var formattedDate = date.toLocaleString('en-GB', options);
                arr.push({
                    selectedDate: formattedDate,
                    startTime: new Date(selectedTime).toLocaleTimeString('en-US'),
                    endTime: new Date(selectedEndTime).toLocaleTimeString('en-US')
                });
            }
            setSelectedDates(arr);
            setState([
                {
                    startDate: new Date(),
                    endDate: null,
                    key: 'selection'
                }
            ]);
            setSelectedTime(null);
            setSelectedEndTime(null);
        }
    }

    function getDatesBetween(startDate, endDate) {
        // Create an empty array to store the dates
        var dates = [];

        // Convert the provided dates to Date objects
        var currentDate = new Date(startDate);
        var finalDate = new Date(endDate);

        // Loop through all the dates until the current date is less than the final date
        while (currentDate <= finalDate) {
            // Add the current date to the array
            dates.push(new Date(currentDate));

            // Increment the current date by 1 day
            currentDate.setDate(currentDate.getDate() + 1);
        }

        // Return the array of dates
        return dates;
    }

    function calculateTimeDifference(startTime, endTime) {
        var start = new Date("1970-01-01 " + startTime);
        var end = new Date("1970-01-01 " + endTime);

        var diffInMilliseconds = end - start;
        var diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

        return diffInMinutes;
    }

    const handleRemoveDateSlot = (index) => {
        setSelectedDates(prevArray => {
            const newArr = [...prevArray];
            newArr.splice(index, 1);
            return newArr;
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (selectedDates.length == 0) {
            enqueueSnackbar("Please select some dates", { variant: 'warning' });
        } else {
            let payload = {
                userId: user._id,
                availability: selectedDates
            }

            dispatch(updateAvailabilityById(payload, (data) => {
                enqueueSnackbar("Availability updated successfully", { variant: 'success' });
                navigate('/coach/edit-availibility');
            }, (err) => {
                enqueueSnackbar("Error Occrred! please try again", { variant: 'error' });
            }))
        }
    }

    return (
        <>
            <Layout>
                <UserLayout>
                    <Box sx={{ display: 'flex', flexDirection: 'row', my: 8, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>My Availability</Typography>
                        {/* <TextField
                            sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)', }} // Updated style
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            onChange={handleSearch}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                            }}
                        /> */}
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={8.5}>
                            <Paper elevation={4}>
                                <DateRange
                                    editableDateInputs={true}
                                    onChange={item => setState([item.selection])}
                                    moveRangeOnFirstSelection={false}
                                    ranges={state}
                                />
                            </Paper>
                            <Grid container spacing={2} mt={5}>
                                <Grid item xs={10}>
                                    <Paper sx={{ padding: '1rem' }}>
                                        <Grid container>
                                            <Grid item xs={5}>
                                                <DatePicker
                                                    selected={selectedTime}
                                                    onChange={handleTimeChange}
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    timeIntervals={15}
                                                    dateFormat="h:mm aa"
                                                    placeholderText="Enter Starting time"
                                                    className="timePicker"
                                                />
                                            </Grid>
                                            <Grid item xs={2}></Grid>
                                            <Grid item xs={5}>
                                                <DatePicker
                                                    selected={selectedEndTime}
                                                    onChange={handleTimeEndChange}
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    timeIntervals={15}
                                                    dateFormat="h:mm aa"
                                                    placeholderText="Enter Ending time"
                                                    className="timePicker"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={2}>
                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <p
                                            style={{
                                                borderRadius: '50%',
                                                background: '#2544EE',
                                                color: '#FFFFFF',
                                                fontWeight: '600',
                                                padding: '2px 16px',
                                                fontSize: '30px',
                                                width: '50px',
                                                height: '50px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={handleAddAvailability}
                                        >
                                            +
                                        </p>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={3.5}>
                            <Paper>
                                <Typography className="subHeading2Bold" sx={{ textAlign: 'center' }}>Selected Time</Typography>
                                <Divider sx={{ border: '1px solid #E2E2E2' }} />
                                {selectedDates.map((item, index) => (
                                    <Box sx={{ padding: '2rem 1rem' }} key={index}>
                                        <Typography className="subHeading2Bold" sx={{ ml: 1 }}>{item.selectedDate}</Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', border: '1px solid #2544EE', borderRadius: '50px', padding: '5px 10px' }}>
                                            <Typography className="text2Mid" sx={{ textAlign: 'center', marginTop: '0.3rem' }}>{item.startTime} - {item.endTime}</Typography>
                                            <Typography>|</Typography>
                                            <Typography className="text2Mid" sx={{ textAlign: 'center', color: '#2544EE', marginTop: '0.3rem' }}>Slot : {calculateTimeDifference(item.startTime, item.endTime)} min</Typography>
                                            <DeleteOutline className="subHeading1Mid" sx={{ backgroundColor: '#FF0303', color: '#fff', borderRadius: '50%', width: '1.75rem', height: '1.75rem', padding: '0.3rem', cursor: 'pointer' }} onClick={() => handleRemoveDateSlot(index)} />
                                        </Box>
                                    </Box>
                                ))}
                            </Paper>
                        </Grid>
                    </Grid>
                </UserLayout>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button onClick={handleSubmit} variant="contained" sx={{ backgroundColor: "#2544EE", borderRadius: '20px' }}>
                            + Update Availability
                        </Button>
                    </Box>
                </Grid>
            </Layout>
        </>
    )
}

export default EditAvailability;